/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.1",
    versionName: "0.4.1",
    versionChannel: "stable",
    buildDate: "2026-07-19T15:08:43.722Z",
    commitHash: "a1ac4ce8647352ad03044031cad0454a636427b8",
};
